import universal from 'react-universal-component';

export default universal(() => import('./Predictions'));



// WEBPACK FOOTER //
// ./src/app/views/Predictions/index.js